import { render, staticRenderFns } from "./LiveDiSelect.vue?vue&type=template&id=55f933ec&"
import script from "./LiveDiSelect.vue?vue&type=script&lang=js&"
export * from "./LiveDiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f933ec')) {
      api.createRecord('55f933ec', component.options)
    } else {
      api.reload('55f933ec', component.options)
    }
    module.hot.accept("./LiveDiSelect.vue?vue&type=template&id=55f933ec&", function () {
      api.rerender('55f933ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/druginfo-manage/LiveDiSelect.vue"
export default component.exports